// extracted by mini-css-extract-plugin
module.exports = {"dropdown_container":"DropDownBlock_dropdown_container__yGqKG"};